// firebase.service.ts
import { Injectable } from '@angular/core';
import { SwipesumAPI } from '../core/swipesum';
import { FirebaseService } from './firebase-service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private readonly swipesumAPI: SwipesumAPI, private readonly firebaseService: FirebaseService) {
  }

  async googleLogin(): Promise<any> {
    const uid = await this.firebaseService.googleLogin();
    //const response = await this.swipesumAPI.apiCall('/auth/google-signin', 'POST', this.swipesumAPI.getDefaultHeaders(), null, {uid: uid});
    // if (response.status !== 200) {
    //   throw new Error('Failed to login with Google. Status code: ' + response.status);
    // }
    return await this.swipesumAPI.apiCall('/auth/google-signin', 'POST', this.swipesumAPI.getDefaultHeaders(), null, {uid: uid});
  }

  async firebaseResetPassword(email: string): Promise<any> {
    return await this.firebaseService.resetPassword(email);
  }

  async signin(email: string, password: string): Promise<any> {
    // return await signin(email, password);
    return await this.swipesumAPI.apiCall('/auth/signin', 'POST', this.swipesumAPI.getDefaultHeaders(), null, { email, password });
  }

  async signIn2FA(twoFactorCode: string, userId: string): Promise<any> {
    return await this.swipesumAPI.apiCall('/auth/tfa', 'POST', this.swipesumAPI.getDefaultHeaders(), null, { code:twoFactorCode, userId: userId });
  }

  async getAccount(uid: string): Promise<any> {
    // return await getAccount(auth, uid);
  }

}